import { FunctionComponent, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { AppointmentListItem } from '@spike/appointments-list-model';
import clsx from 'clsx';
import ClickAwayListener from 'components/CreateBooking/UI/ClickAwayListener';
import styles from './BookingSelector.module.scss';

interface BookingSelectorProps {
    bookings: Array<AppointmentListItem>;
    selectedBookingId?: number;
    placeholder?: string;
    className?: string;
    onSelect: (bookingId: number, appointmentId: number) => void;
}

const bookingLabel = (booking: AppointmentListItem) =>
    `${booking.customer.firstName} ${booking.customer.lastName}'s Booking`;

export const BookingSelector: FunctionComponent<BookingSelectorProps> = ({
    bookings,
    selectedBookingId,
    placeholder = 'Select Booking',
    className,
    onSelect
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const selectedBooking = bookings.find(b => b.bookingId === selectedBookingId);

    return (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
            <div className={clsx(styles.container, className)}>
                <span className={styles.label}>
                    Booking <span className={styles.required}>*</span>
                </span>
                <div className={styles.dropdownContainer}>
                    <div
                        className={clsx(styles.border, {
                            [styles.collapsed]: !isOpen,
                            [styles.expanded]: isOpen
                        })}
                    >
                        <div
                            className={styles.headerContainer}
                            onClick={() => setIsOpen(prev => !prev)}
                        >
                            <div className={styles.textContainer}>
                                <span
                                    className={clsx(styles.header, {
                                        [styles.placeholder]: !selectedBooking
                                    })}
                                >
                                    {selectedBooking ? bookingLabel(selectedBooking) : placeholder}
                                </span>
                            </div>
                            <div className={styles.chevronContainer}>
                                <FontAwesomeIcon
                                    icon={isOpen ? faChevronUp : faChevronDown}
                                    color={isOpen ? '#222222' : '#7A7A7A'}
                                    className={styles.chevron}
                                />
                            </div>
                        </div>

                        {isOpen && (
                            <div className={styles.listContainer}>
                                {bookings.map(booking => (
                                    <div
                                        key={booking.bookingId}
                                        className={styles.item}
                                        onClick={() => {
                                            onSelect(booking.bookingId, booking.appointmentId);
                                            setIsOpen(false);
                                        }}
                                    >
                                        {bookingLabel(booking)}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ClickAwayListener>
    );
};

export default BookingSelector;
